import { CheckBoxField } from "ui/CheckBox";
import { InputField } from "ui/Input";
import { FieldProps } from "./types";
import { getSyncStatusMessage } from "../../helpers/getSyncStatusMessage";

const ContractNumberField = ({
  control,
  errors,
  watch,
  contractLoading,
  isShown,
  isRequired,
  setValue,
  contract,
}: FieldProps) => {
  const syncStatusMessage = getSyncStatusMessage("Номер договора", contract);
  const isDisabled = !!watch("noNumber") || contractLoading || !!syncStatusMessage

  if (!isShown) return null;

  return (
    <div className="row align-items-center">
      <div className="col-sm-9">
        <InputField
          name="contract_number"
          title="Номер договора"
          maxLength={150}
          control={control}
          errors={errors}
          isRequired={!watch("noNumber") && !!isRequired}
          isStared={!watch("noNumber")}
          disabled={isDisabled}
          isClearable
          infoText={`${syncStatusMessage}`}
        />
      </div>
      <div className="col-sm-3 mt-4">
        <CheckBoxField // только для доп соглашения
          name="noNumber" // не отправляется на сервер
          title="Нет номера"
          control={control}
          errors={errors}
          isChecked={!!watch("noNumber") || !!contractLoading}
          extraAction={() => {
            setValue("contract_number", null);
          }}
          disabled={contractLoading || !!syncStatusMessage}
        />
      </div>
    </div>
  );
};

export default ContractNumberField;
